module.exports = __webpack_public_path__ + "img/clochette-blanche.b373a6e9.png";